import { st } from "rdflib";
import { vcard } from "../namespaces.js";
export function removePhoneNumber(contactNode, phoneNode, store) {
    const phoneStatements = store.statementsMatching(phoneNode, null, null, phoneNode.doc());
    return {
        insertions: [],
        deletions: [
            ...phoneStatements,
            st(contactNode, vcard("hasTelephone"), phoneNode, contactNode.doc()),
        ],
        filesToCreate: [],
    };
}
//# sourceMappingURL=removePhoneNumber.js.map